import React from "react";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardIcon from "@material-ui/icons/Dashboard";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import EventNoteIcon from "@material-ui/icons/EventNote";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import SecurityIcon from "@material-ui/icons/Security";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import { theme } from "./tema/tema";
import {
  useLocation,
  Switch,
  Route,
  Redirect,
  NavLink,
  Link,
} from "react-router-dom";
import ProgramacionHub from "./admin/programacion/ProgramacionHub";
import BandaHorariaHub from "./admin/bandaHoraria/BandaHorariaHub";
import { alpha } from "@material-ui/core";
import logo from "./assets/logo-avellaneda.png";
import SeguridadHub from "./admin/seguridad/SeguridadHub";
import ParametrosHub from "./admin/parametros/ParametrosHub";
import Dashboard from "./admin/dashboard/Dashboard";
import Login from "Login";
import TurnosHub from "admin/turnos/TurnosHub";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { es } from "date-fns/locale";
import WebExterna from "./externo/WebExterna";
import ReservarTurno from "externo/ReservarTurno";
import ReservarTurnoInterno from "admin/turnos/ReservarTurnoInerno";
import DetalleTurno from "admin/turnos/DetalleTurno";
import FeriadoHub from "admin/feriados/FeriadoHub";
import MiCuentaHub from "admin/miCuenta/MiCuentaHub";
import CambiarPasswordExterna from "admin/miCuenta/CambiarPasswordExterna";
import { PERMISOS } from "helpers/PermisosConfig";
import axios from "helpers/API";
import PetsIcon from "@material-ui/icons/Pets";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { ForbiddenPage } from "Forbidden";
import Permisos from "helpers/Permisos";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';

const drawerWidth = 240;
const tema = theme;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    background: "#232323",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#232323",
    color: "#fff",
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,

  appBar: {
    top: 0,
    float: "right",
    display: "flex",
    justifyContent: "flex-end",
  },
  search: {
    position: "absolute",
    bottom: 0,
    borderRadius: theme.shape.borderRadius,
    color: "#fff",
    backgroundColor: alpha(theme.palette.common.white, 0.3),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    boxShadow: "2px 2px 2px 2px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    // padding: theme.spacing(1, 1, 1, 0),
    // // vertical padding + font size from searchIcon
    color: "inherit",
    paddingLeft: `calc(1em + ${theme.spacing(3)}px)`,
    paddingRight: "10%",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: "flex",
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    background: "#232323",

    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    background: "#232323",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
}));

function App() {
  const classes = useStyles();
  const location = useLocation();

  const [permisos, setPermisos] = React.useState(null);

  React.useEffect(() => {
    const userData = localStorage.getItem("usuariosData")
      ? JSON.parse(localStorage.getItem("usuariosData"))
      : null;
    const token = userData && userData.token ? userData.token : "";
    if (token !== "") {
      axios
        .post("/seguridad/usuarios/permisos/listarMenu", {})
        .then(function (response) {
          setPermisos(response.data.permisos);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, [location]);

  const hasMenu = (menu) => {
    if (permisos) {
      return (
        permisos.filter((perm) => {
          return perm.includes(menu);
        }).length > 0
      );
    }
    return false;
  };

  const rutasExternas = (flagExterno, flagDefault) => {
    switch (location.pathname) {
      case "/":
        return flagExterno;
      case "/detalleTurno":
        return flagExterno;
      case "/reservarTurno":
        return flagExterno;
      case "/cancelarTurno":
        return flagExterno;
      case "/verTurno":
        return flagExterno;
      case "/cuenta/cambiarClave":
        return flagExterno;
      case "/login":
        return flagExterno;
      case "/prohibido":
        return flagExterno;
      default:
        return flagDefault;
    }
  };

  const [open, setOpen] = React.useState(true);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
      <ThemeProvider theme={tema}>
        <div className={classes.root}>
          <CssBaseline />
          <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            })}
            classes={{
              paper: clsx({
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
              }),
            }}
            style={{display: rutasExternas("0", "") ? "none" : "initial"}}
          >
            <div className={classes.toolbar}>
              <List component="div">
                <ListItem component="div">
                  <ListItemIcon
                    onClick={() => setOpen(!open)}
                    style={{ color: "white" }}
                  >
                    <MenuIcon />
                  </ListItemIcon>
                  {open && (
                  <ListItem>
                    <img src={logo} style={{ width: "100%" }} />
                  </ListItem>
                )}
                </ListItem>
              </List>
            </div>
            <List component="div">
              {hasMenu(PERMISOS.M_DASHBOARD) && (
                <ListItem
                  component={NavLink}
                  activeClassName="selected"
                  to={"/administracion"}
                  exact
                >
                  <ListItemIcon style={{ color: "white" }}>
                    <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Dashboard"} />
                </ListItem>
              )}

              {hasMenu(PERMISOS.M_TURNOS) && (
                <ListItem
                  component={NavLink}
                  activeClassName="selected"
                  to={"/turnos"}
                >
                  <ListItemIcon style={{ color: "white" }}>
                    <EventAvailableIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Turnos"} />
                </ListItem>
              )}

              {hasMenu(PERMISOS.M_ADMINISTRAR_BANDAS_HORARIAS) && (
                <ListItem
                  component={NavLink}
                  activeClassName="selected"
                  to={"/bandaHoraria"}
                >
                  <ListItemIcon style={{ color: "white" }}>
                    <AccessTimeIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Banda Horaria"} />
                </ListItem>
              )}

              {hasMenu(PERMISOS.M_CONSULTA_PROGRAMACION_TURNOS) && (
                <ListItem
                  component={NavLink}
                  activeClassName="selected"
                  to={"/programacion"}
                >
                  <ListItemIcon style={{ color: "white" }}>
                    <EventNoteIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Programación"} />
                </ListItem>
              )}

              {hasMenu(PERMISOS.M_ADMINISTRAR_FERIADOS) && (
                <ListItem
                  component={NavLink}
                  activeClassName="selected"
                  to={"/feriados"}
                >
                  <ListItemIcon style={{ color: "white" }}>
                    <InsertInvitationIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Feriados"} />
                </ListItem>
              )}

              {hasMenu(PERMISOS.M_ADMINISTRAR_PARAMETROS_SISTEMA) && (
                <ListItem
                  component={NavLink}
                  activeClassName="selected"
                  to={"/parametros"}
                >
                  <ListItemIcon style={{ color: "white" }}>
                    <SettingsEthernetIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Parametros"} />
                </ListItem>
              )}

              {hasMenu(PERMISOS.M_SEGURIDAD) && (
                <ListItem
                  component={NavLink}
                  activeClassName="selected"
                  to={"/seguridad"}
                >
                  <ListItemIcon style={{ color: "white" }}>
                    <SecurityIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Seguridad"} />
                </ListItem>
              )}

              {hasMenu(PERMISOS.M_CUENTA) && (
                <ListItem
                  component={NavLink}
                  activeClassName="selected"
                  to={"/miCuenta"}
                >
                  <ListItemIcon style={{ color: "white" }}>
                    <AccountBoxIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Mi Cuenta"} />
                </ListItem>
              )}
            </List>
          </Drawer>

          <main
            style={{ padding: rutasExternas("0", "") }}
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
            {localStorage.getItem("usuariosData") &&
              location.pathname != "/logout" &&
              !rutasExternas("0", "") && (
                <AppBar
                  elevation={0}
                  color="transparent"
                  position="static"
                  className={classes.appBar}
                >
                  <Toolbar className={classes.appBar}>
                    <Typography variant="h6">
                      ¡Hola{" "}
                      {JSON.parse(localStorage.getItem("usuariosData")).nombre +
                        " " +
                        JSON.parse(localStorage.getItem("usuariosData"))
                          .apellido +
                        "!"}
                    </Typography>
                    <Link
                      activeClassName="selected"
                      to={{
                        pathname: "/login",
                        state: {
                          info: true,
                          msgInfo: "Ha cerrado sesión",
                        },
                      }}
                      style={{ marginLeft: "2%" }}
                    >
                      <Typography
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        Cerrar Sesión{" "}
                      </Typography>
                    </Link>
                  </Toolbar>
                </AppBar>
              )}
            <Switch>
              <Route exact path="/" render={() => <WebExterna />} />
              <Route
                exact
                path="/reservarTurno"
                render={() => <ReservarTurno />}
              />
              <Route
                exact
                path="/detalleTurno"
                render={() => <DetalleTurno />}
              />
              <Route
                exact
                path="/cancelarTurno"
                render={() => <WebExterna />}
              />
              <Route exact path="/verTurno" render={() => <WebExterna />} />
              <Route
                path="/reservaTurnoInterno"
                render={() => <ReservarTurnoInterno />}
              />
              <Route path="/administracion" render={() => <Dashboard />} />
              <Route path="/turnos" render={() => <TurnosHub />} />
              <Route
                path="/bandaHoraria"
                render={() => (
                  <Permisos permiso={PERMISOS.P_ADMINISTRAR_BANDAS_HORARIAS}>
                    <BandaHorariaHub />
                  </Permisos>
                )}
              />
              <Route
                path="/programacion"
                render={() => (
                  <Permisos permiso={PERMISOS.P_CONSULTA_PROGRAMACION_TURNOS}>
                    <ProgramacionHub />
                  </Permisos>
                )}
              />
              <Route
                path="/parametros"
                render={() => (
                  <Permisos permiso={PERMISOS.P_ADMINISTRAR_PARAMETROS_SISTEMA}>
                    <ParametrosHub />
                  </Permisos>
                )}
              />
              <Route path="/seguridad" render={() => <SeguridadHub />} />
              <Route
                path="/feriados"
                render={() => (
                  <Permisos permiso={PERMISOS.P_ADMINISTRAR_FERIADOS}>
                    <FeriadoHub />
                  </Permisos>
                )}
              />
              <Route path="/miCuenta" render={() => <MiCuentaHub />}  />
              <Route
                path="/cuenta/cambiarClave"
                render={() => <CambiarPasswordExterna />}
              />
              <Route path="/login" render={() => <Login />} />
              <Route path="/prohibido" render={() => <ForbiddenPage />} />
              <Route render={() => <Redirect to="/" />} />
            </Switch>
          </main>
        </div>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
}
export default App;
